import Utils from "../../utils/Utils";
import getMatches from "./services/getMatches";
import Translator from "../../requests/apa/Translator";
import store from "../../store";
import { playFullMedia } from "../../actions/playmedia";

import React from 'react'
import { PartidosTab, TablaDePosicionesTab, EstadisticasDeJuegoTab, PaisesTab, matchInProgress, matchCompleted, MUNDIAL_2026, PARTIDO_POR_DEFINIR, GANADOR, PERDEDOR, SEGUNDO, TERCERO, PLAYBACK_AKT_SEED_CONFIG_DEFAULT } from './constants'
import Partidos from './Partidos'
import TablaDePosiciones from './TablaDePosiciones'
import Countries from './Paises'
import EstadisticasJuegos from './EstadisticasJuegos'
import { s } from "redom";
import { GA4 } from '../../utils/trackers/GA4'
import Assets from '../../requests/apa/Asset';
import logger from 'src/utils/logger/logger';
import Translations from '../../requests/apa/Translator';
import { CANCHA_ICONS } from '../Mundial2026/FootballMatchDetail/mock/matchDetailLineupsData';
import Asset from "../../requests/apa/Asset";
import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';

export function formatDate(isoDate) {
  const MONTHS_ES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                     'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  // Se extrae YYYY-MM-DD directamente del string para evitar
  // que la conversión a UTC desplace el día cuando el offset es negativo.
  // Ej: 2026-06-11T20:00:00-06:00 → UTC 2026-06-12 → getUTCDate() devuelve 12 (incorrecto).
  const datePart = isoDate ? String(isoDate).substring(0, 10) : '';
  const parts = datePart.split('-');
  if (parts.length < 3) return '';
  const day = parseInt(parts[2], 10);
  const month = MONTHS_ES[parseInt(parts[1], 10) - 1];
  return `${day} de ${month}`;
}

export const getMatchesByJourney = (allMatches) => {
    const journeys = [];

    for (let i = 0; i < allMatches.length; i += 2) {
        const pair = allMatches.slice(i, i + 2);
        journeys.push({
            date: formatDate(pair[0].scheduledAt),
            matches: pair.map(getMatchData),
        });
    }

    return journeys;
}

export const getIsPendingTeam = (teamName) => {
    const name = teamName ? teamName.toUpperCase() : '';
    return name === PARTIDO_POR_DEFINIR ||
      [GANADOR, PERDEDOR, SEGUNDO, TERCERO].some(function(keyword) { return name.indexOf(keyword) !== -1; });
};

export const getMatchData = (match) => {
    const isPendingHomeTeam = getIsPendingTeam(match.homeTeam.name);
    const isPendingAwayTeam = getIsPendingTeam(match.awayTeam.name);
    return {
        id: match.matchId,
        time:match.displayTime,
        timezone: match.timeZoneLabel,
        scheduledAt: formatDate(match.scheduledAt),
        venue: `${match.venue.name}, ${match.venue.city}`,
        status: match.status,
        nextMatchId: match.nextMatchId,
        homeTeam: {
            id: match.homeTeam.id,
            name: match.homeTeam.name,
            flagUrl: isPendingHomeTeam
              ? Asset.get('eventodeportivo_carruseletapas_ficha_imagen_placeholder1') : match.homeTeam && match.homeTeam.flagUrl
                  ? match.homeTeam.flagUrl
                  : Asset.get('eventodeportivo_placeholder_imagen_bandera_1'),
            score: match.score && match.score.home ? match.score.home : 0
        },
        awayTeam: {
            id: match.awayTeam.id,
            name: match.awayTeam.name,
            flagUrl: isPendingAwayTeam
              ? Asset.get('eventodeportivo_carruseletapas_ficha_imagen_placeholder1') : match.awayTeam && match.awayTeam.flagUrl
                  ? match.awayTeam.flagUrl
                  : Asset.get('eventodeportivo_placeholder_imagen_bandera_1'),
            score: match.score && match.score.away ? match.score.away : 0
        },
        broadcast: match.broadcast,
        matchProgress: match.matchProgress

    }
}

export const getElementByPosition = (value, position) => {
    if (typeof value !== 'string') return null

    if (!value.includes(',')) {
      return position === 0 ? value.trim() : null
    }

    const items = value
    .split(',')
    .map(item => item.trim())

    return items[position] || null
}

export const getIdLeage = () => {
    const pathname = window.location.pathname
    const code = pathname.split('/').filter(Boolean).pop()
    const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
    const idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
    return idLeague
}

export const getMatchesGroups = async (phase = '') => {
    const idLeague = getIdLeage()
    try {
        const matches = await getMatches(idLeague, phase)

        if (!matches) return

        const groups = matches.matchesPerGroup && matches.activeGroup
        ? matches.matchesPerGroup[matches.activeGroup] || []
        : []
        return groups

    } catch (error) {
        logger.error("[Error trying getMatchesGroups]", error)
    }
}

export const getAllMatches = (roundsObj) => {
    const result = [];

    if (!roundsObj) return result;

    Object.keys(roundsObj).forEach(function (roundKey) {
        const round = roundsObj[roundKey];

        if (!round || !round.length) return;

        round.forEach(function (match) {
            if (match) {
                result.push(match);
            }
        });
    });
    return result;
};

export const getCommonNextMatchId = (matches) => {
    if (!matches || !matches.length) return null;

    let firstId = null;

    for (let i = 0; i < matches.length; i++) {
        const match = matches[i];
        if (!match) continue;

        // Escenario 3: si algún nextMatchId es null, retorna null inmediatamente
        if (match.nextMatchId == null) return null;

        if (firstId === null) {
            firstId = match.nextMatchId;
        } else if (match.nextMatchId !== firstId) {
            // Escenario 2: no todos coinciden
            return null;
        }
    }
    // Escenario 1: todos coinciden
    return firstId;
}

export const formatScheduledAtDate = (date) => {
    // Example: 14 Julio
    const parts = date.split(' ');
    const day = parts[0];
    const month = parts[2];
    const shortMonth = month.slice(0, 3);
    return `${day} ${shortMonth.toUpperCase()}`
}

// export const getMatchTimeLabel = (isLiveOrFinished, status, time, timezone, scheduledAt, hasScheduledAt) => {
//     let text = '';

//     if (isLiveOrFinished) {
//         const key = `eventodeportivo_carruseletapas_ficha_texto_${status}`
//         text = Translator.get(key);
//     } else if (time && timezone) {
//         const separator = Translator.get('eventodeportivo_carruseletapas_ficha_texto_separacion');
//         const scheduledAtFormated = hasScheduledAt ? formatScheduledAtDate(scheduledAt) : ''
//         text = hasScheduledAt ?
//             `${scheduledAtFormated} - ${time} ${separator} ${timezone}` :
//             `${time} ${separator} ${timezone}`;
//     } else {
//         return time || '--:--';
//     }
//     return Utils.cutPlayerString(text, 26);
// }

export const getMatchTimeLabel = (status, time, timezone, scheduledAt, minute) => {
    if(status === matchInProgress) {
        return minute ?`${Translator.get(`eventodeportivo_carruseletapas_ficha_texto_${status}`)} ${minute}'` : Translator.get(`eventodeportivo_carruseletapas_ficha_texto_${status}`);
    }

    if(status === matchCompleted) {
        return Translator.get(`eventodeportivo_carruseletapas_ficha_texto_${status}`);
    }

    if (time && timezone) {
        const separator = Translator.get('eventodeportivo_carruseletapas_ficha_texto_separacion');
        const scheduledAtFormated = scheduledAt ? formatScheduledAtDate(scheduledAt) : ''
        return scheduledAt ?
            `${scheduledAtFormated} - ${time} ${separator} ${timezone}` :
            `${time} ${separator} ${timezone}`;
    }

    return time || '--:--';
}

export const getNodeCode = () => {
    const pathname = window.location.pathname;
    const code = pathname.split('/').filter(Boolean).pop();
    return code;
}

export const components = {
    [PartidosTab]: Partidos,
    [TablaDePosicionesTab]: TablaDePosiciones,
    [EstadisticasDeJuegoTab]: EstadisticasJuegos,
    [PaisesTab]: Countries,
}

export const getTabComponent = (idTab, reloadKey = 0) => {
    const Component = components[idTab]
    return Component ? <Component key={`${idTab}-${reloadKey}`} sectionId={idTab} /> : null
}

export const getTabsSecondLevel = (tabs) => {
    return tabs.map(tab => ({
        id: tab.id || tab.label,
        label: Utils.cutPlayerString(Translator.get(tab.label), tab.maxCharacteres)
    }))
}

export const getIsMundial2026 = (code) => {
    return code ? code === MUNDIAL_2026 : false
}

export const playmatch = (groupid, pinAlreadyValidated) => {
    store.dispatch(playFullMedia(Object.assign({
        playerstate: 'PLAYING',
        source: {
            videoid: groupid,
        },
        ispreview: false,
        islive: true,
        size: {
            top: 0,
            left: 0,
            width: 792,
            height: 428
        },
        ispip: false,
        showEpg: false,
        filterTV: undefined,
        event: null,
        playFromCard: true
    }, pinAlreadyValidated === true ? { pinAlreadyValidated: true } : {})))
}

export const getPagePath = (mainMenu, parentTab, childTab) => {
    const pathname = window.location.pathname;

    const normalize = (text = '') => {
      // Si viene vacío o solo contiene espacios
      if (!text || text.trim() === '') {
        return null;
      }

      return text
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_');
    };

    const path = [
      pathname,
      normalize(mainMenu),
      normalize(parentTab),
      normalize(childTab)
    ]
      .filter(Boolean)
      .join('/');

    return path;
  }

export const sendMetricSelectContent = (mainMenuLabel, parentLabel, childLabel, match = {}) => {
    const history = window.history
    const interaction_type = null
    const moduloName = parentLabel && childLabel ? `${parentLabel}, ${childLabel}` : parentLabel
    const pagePath = getPagePath(mainMenuLabel, parentLabel, childLabel)
    const contentSection = window.location.pathname.split('/').filter(Boolean).pop() || null;
    const contentSubsection = mainMenuLabel ? mainMenuLabel : null

    const dataMetrics = {
        history,
        interaction_type,
        modulo_name: moduloName,
        page_path: pagePath,
        page_title: contentSection,
        page_url: window.location.href,
        content_section: contentSection,
        content_subsection: contentSubsection,
        content_type: contentSection,
        match
    }

    const gA4 = new GA4()
    gA4.sendMetricsMundialFase2SelectContent(dataMetrics)
}

export const sendMetricScroll = (mainMenuLabel, parentLabel, childLabel, scrollPercent) => {
    const history = window.history
    const interaction_type = null
    const moduloName = parentLabel && childLabel ? `${parentLabel}, ${childLabel}` : parentLabel
    const pagePath = getPagePath(mainMenuLabel, parentLabel, childLabel)
    const contentSection = window.location.pathname.split('/').filter(Boolean).pop() || null;
    const contentSubsection = mainMenuLabel ? mainMenuLabel : null

    const dataMetrics = {
        history,
        interaction_type,
        modulo_name: moduloName,
        page_path: pagePath,
        page_title: contentSection,
        page_url: window.location.href,
        content_section: contentSection,
        content_subsection: contentSubsection,
        scroll_percentage: scrollPercent
    }

    const gA4 = new GA4()
    gA4.sendMetricsMundialFase2Scroll(dataMetrics)
}

export const sendMetricViewItem = (mainMenuLabel, parentLabel, childLabel, buttonName) => {
    const history = window.history
    const moduloName = parentLabel && childLabel ? `${parentLabel}, ${childLabel}` : parentLabel
    const pagePath = getPagePath(mainMenuLabel, parentLabel, childLabel)
    const contentSection = window.location.pathname.split('/').filter(Boolean).pop() || null;
    const contentSubsection = mainMenuLabel ? mainMenuLabel : null

    const dataMetrics = {
        history,
        interaction_type: buttonName ? buttonName : null,
        modulo_name: moduloName,
        page_path: pagePath,
        page_title: contentSection,
        page_url: window.location.href,
        content_section: contentSection,
        content_subsection: contentSubsection,
        content_type: contentSection,
        item_name: buttonName ? buttonName : null,
    }

    const gA4 = new GA4()
    gA4.sendMetricsMundialFase2ViewItem(dataMetrics)
}

export const sendMetricContentPlay = (mainMenuLabel, parentLabel, childLabel, match = {}) => {
    const history = window.history
    const interaction_type = null
    const moduloName = parentLabel && childLabel ? `${parentLabel}, ${childLabel}` : parentLabel
    const pagePath = getPagePath(mainMenuLabel, parentLabel, childLabel)
    const contentSection = window.location.pathname.split('/').filter(Boolean).pop() || null;
    const contentSubsection = mainMenuLabel ? mainMenuLabel : null

    const dataMetrics = {
        history,
        interaction_type,
        modulo_name: moduloName,
        page_path: pagePath,
        page_title: contentSection,
        page_url: window.location.href,
        content_section: contentSection,
        content_subsection: contentSubsection,
        content_type: contentSection,
        match
  }

  const gA4 = new GA4()
  gA4.sendMetricsMundialFase2ContentPlay(dataMetrics)
}

export const buildStatsData = (matchStats) => {
  if (!matchStats) return [];

  const data = matchStats.data || matchStats;
  const teamStatistics = Array.isArray(data.teamStatistics) ? data.teamStatistics[0] : null;
  if (!teamStatistics) return [];

  const home = teamStatistics.home || {};
  const away = teamStatistics.away || {};

  const matchCard = Array.isArray(data.matchCard) ? data.matchCard[0] : null;
  const homeTeamApi = matchCard && matchCard.summary && matchCard.summary.matchDetails && matchCard.summary.matchDetails.home && matchCard.summary.matchDetails.home.team ? matchCard.summary.matchDetails.home.team : {};
  const awayTeamApi = matchCard && matchCard.summary && matchCard.summary.matchDetails && matchCard.summary.matchDetails.away && matchCard.summary.matchDetails.away.team ? matchCard.summary.matchDetails.away.team : {};
  const homeColor = homeTeamApi.primaryHex || '#0f0f10';
  const awayColor = awayTeamApi.primaryHex || '#e1d8d8';

  const calcPercent = (leftRaw, rightRaw) => {
    const l = parseFloat(leftRaw) || 0;
    const r = parseFloat(rightRaw) || 0;
    const total = l + r;
    return total === 0 ? 50 : Math.round((l / total) * 100);
  };

  const row = (label, leftRaw, rightRaw, isPercent, isAccuracy) => (
    {
    label,
    leftValue: isPercent || isAccuracy? leftRaw + '%' : (parseFloat(leftRaw) || 0),
    rightValue: isPercent || isAccuracy ? rightRaw + '%' : (parseFloat(rightRaw) || 0),
    leftPercent: isPercent ? (parseFloat(leftRaw) || 50) : calcPercent(leftRaw, rightRaw),
    leftColor: homeColor,
    rightColor: awayColor
    }
  );

  return [
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_posesion'),           home.ballPossession,     away.ballPossession,     true),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_tirostotales'),      home.shotsTotal,         away.shotsTotal,         false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_tirosporteria'),   home.shotsOnGoal,        away.shotsOnGoal,        false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_tirosfuera'),      home.shotsWide,          away.shotsWide,          false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_tirosbloqueados'),   home.shotsBlocked,       away.shotsBlocked,       false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_paradasportero'),home.savesByGoalkeeper,  away.savesByGoalkeeper,  false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_tarjetasrojas'),     home.cardsRed,           away.cardsRed,           false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_tarjetasamarillas'), home.cardsYellow,        away.cardsYellow,        false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_faltas'),   home.fouls,              away.fouls,              false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_entradasganadas'),     home.tacklesWon,         away.tacklesWon,         false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_pasestotales'),      home.passesTotal,        away.passesTotal,        false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_precisionpases'), home.passAccuracy,       away.passAccuracy,  false, true),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_saquesequina'),  home.corners,            away.corners,            false),
    row(Translations.get('eventodeportivo_partidos_estadisticas_texto_titulo_fuerajuego'),     home.offsides,           away.offsides,           false)
  ];
}

export const buildPlayersData = (matchStats) => {
    if (!matchStats) return null;

    const data = matchStats.data || matchStats;
    const players = Array.isArray(data.players) ? data.players : [];
    if (!players.length) return null;

    const matchCard = Array.isArray(data.matchCard) ? data.matchCard[0] : null;
    const matchDetails = matchCard && matchCard.summary && matchCard.summary.matchDetails ? matchCard.summary.matchDetails : {};
    const homeTeamApi = matchDetails.home && matchDetails.home.team ? matchDetails.home.team : {};
    const awayTeamApi = matchDetails.away && matchDetails.away.team ? matchDetails.away.team : {};

    const ROLE_LABELS = {
      goalkeepers: Translations.get('eventodeportivo_partidos_jugadores_texto_titulo_portero'),
      defenders: Translations.get('eventodeportivo_partidos_jugadores_texto_titulo_defensas'),
      midfielders: Translations.get('eventodeportivo_partidos_jugadores_texto_titulo_mediocampistas'),
      forwards: Translations.get('eventodeportivo_partidos_jugadores_texto_titulo_delanteros')
    };

    const mapPlayerStats = (statistics, isGK) => {
      const s = statistics || {};
      if (isGK) {
        return {
          G: 0,
          PAG: 0,
          TT: 0,
          PT: parseInt(s.passesTotal) || 0,
          EG: parseInt(s.tacklesWon) || 0,
          FJ: 0,
          RE: 0,
          PPA: parseInt(s.passAccuracy) || 0,
          PP: parseInt(s.saves) || 0,
          TAC: parseInt(s.shotsOnTargetAgainst) || 0
        };
      }
      return {
        G: parseInt(s.goals) || 0,
        PAG: parseInt(s.assists) || 0,
        TT: parseInt(s.shotsTotal) || 0,
        PT: parseInt(s.passesTotal) || 0,
        EG: parseInt(s.tacklesWon) || 0,
        FJ: parseInt(s.offsides) || 0,
        RE: 0,
        PPA: parseInt(s.passAccuracy) || 0
      };
    };

    const mapGroup = (playerList, isGK) => {
      if (!Array.isArray(playerList)) return [];
      return playerList.map((p) => ({
        id: p.playerId || p.name,
        name: p.name || '',
        number: p.number || 0,
        photo: p.photo || '',
        stats: mapPlayerStats(p.statistics, isGK)
      }));
    };

    const teams = [];
    const playersByTeam = {};

    players.forEach((teamData) => {
      const teamId = teamData.teamId;
      if (!teamId) return;

      let teamLabel = teamId;
      if (homeTeamApi.teamId === teamId) teamLabel = homeTeamApi.name || teamId;
      else if (awayTeamApi.teamId === teamId) teamLabel = awayTeamApi.name || teamId;

      teams.push({ id: teamId, label: teamLabel });

      const sections = [ 'forwards', 'midfielders','defenders','goalkeepers']
        .filter((key) => Array.isArray(teamData[key]) && teamData[key].length > 0)
        .map((key) => ({
          role: ROLE_LABELS[key],
          players: mapGroup(teamData[key], key === 'goalkeepers')
        }));

      playersByTeam[teamId] = sections;
    });

    if (!teams.length) return null;

    return {
      teams,
      selectedTeamId: teams[0].id,
      playersByTeam,
      legend: [
        { key: 'G', label: 'Goles' },
        { key: 'PAG', label: 'Pases a gol' },
        { key: 'TT', label: 'Tiros totales' },
        { key: 'PT', label: 'Pases totales' },
        { key: 'EG', label: 'Entradas ganadas' },
        { key: 'FJ', label: 'Fuera de juego' },
        { key: 'RE', label: 'Regates exitosos' },
        { key: 'PPA', label: 'Precisión de pases' }
      ],
      statKeys: [ Translations.get('eventodeportivo_siglas_texto_titulo_goles'),
                  Translations.get('eventodeportivo_siglas_texto_titulo_pasesgol'),
                  Translations.get('eventodeportivo_siglas_texto_titulo_tirostotales'),
                  Translations.get('eventodeportivo_siglas_texto_titulo_pasestotales'),
                  Translations.get('eventodeportivo_siglas_texto_titulo_entradasganadas'),
                  Translations.get('eventodeportivo_siglas_texto_titulo_fueradejuego'),
                  Translations.get('eventodeportivo_siglas_texto_titulo_regatesexito'),
                  Translations.get('eventodeportivo_siglas_texto_titulo_precisionpases')]
    };
}

export const buildSummaryData = (matchStats) => {
    if (!matchStats) return [];

    const data = matchStats.data || matchStats;
    const liveEventsBlock = Array.isArray(data.liveEvents) ? data.liveEvents[0] : null;
    if (!liveEventsBlock || !Array.isArray(liveEventsBlock.events)) return [];

    const matchCard = Array.isArray(data.matchCard) ? data.matchCard[0] : null;
    const matchDetails = matchCard && matchCard.summary && matchCard.summary.matchDetails ? matchCard.summary.matchDetails : {};
    const homeTeamId = matchDetails.home && matchDetails.home.team ? matchDetails.home.team.teamId : null;

    const API_TO_EVENT_TYPE = {
      GOAL: 'goal',
      YELLOW_CARD: 'yellow',
      RED_CARD: 'red',
      SECOND_YELLOW_CARD: 'red_second_yellow',
      SUBSTITUTION_OUT: 'substitution',
      FREE_KICK: 'free_kick',
      CORNER: 'corner',
      FOUL: 'foul',
      OFFSIDE: 'offside',
      SHOT_OFF_TARGET: 'shot_out',
      SHOT_ON_TARGET: 'shot',
      SHOT_BLOCKED: 'shot_blocked',
      SHOT_SAVED: 'shot_saved',
      PERIOD_END: 'divisor',
      SECOND_YELLOW_RED_CARD: 'second_yellow_red_card',
      EXTRA_TIME: 'extra_time',
      ADDITIONAL_TIME: 'additional_time', //CORROBORAR CON ARQUITECTURA
      END_OF_PERIOD: 'divisor'
    };

    const normalizeMinuteValue = (value) => {
      if (value === undefined || value === null) return null;
      if (typeof value === 'number' && !Number.isNaN(value)) return value;

      const raw = String(value).replace(/'/g, '').trim();
      if (!raw) return null;

      const extraTimeMatch = raw.match(/^(\d+)\+(\d+)$/);
      if (extraTimeMatch) {
        return parseInt(extraTimeMatch[1], 10) + (parseInt(extraTimeMatch[2], 10) / 100);
      }

      const parsed = parseInt(raw, 10);
      return Number.isNaN(parsed) ? null : parsed;
    };

    const getEventMinute = (event) => {
      const minuteFromMinute = normalizeMinuteValue(event.minute);
      if (minuteFromMinute !== null) return minuteFromMinute;
      return normalizeMinuteValue(event.minuteDisplay);
    };

    const items = [];
    const rawEvents = liveEventsBlock.events.slice();
    const timelineMinutes = rawEvents
      .map(getEventMinute)
      .filter(minute => minute !== null);
    const firstMinute = timelineMinutes.length ? timelineMinutes[0] : null;
    const lastMinute = timelineMinutes.length ? timelineMinutes[timelineMinutes.length - 1] : null;
    const shouldReverseEvents = firstMinute !== null && lastMinute !== null && firstMinute > lastMinute;
    const events = shouldReverseEvents ? rawEvents.reverse() : rawEvents;
    let runningHomeScore = 0;
    let runningAwayScore = 0;

    events.forEach((ev) => {
      const eventType = API_TO_EVENT_TYPE[ev.type];
      if (ev.type === 'SUBSTITUTION_IN') return;

      if (eventType === 'divisor') {
        items.push({ type: 'divisor', label: ev.name || '' });
        return;
      }

      const id = ev.eventId;
      const team = homeTeamId && ev.teamId === homeTeamId ? 'home' : 'away';
      const isAdditionalTimeEvent = ev.type === 'ADDITIONAL_TIME';
      const minute = ev.minuteDisplay ? ev.minuteDisplay + (isAdditionalTimeEvent ? '' : "'") : '';
      const playerName = ev.player ? ev.player.name : '';
      const relatedPlayerName = ev.relatedPlayer && ev.relatedPlayer.name ? ev.relatedPlayer.name : '';
      const assistNameFromApi = (ev.assist && ev.assist.name) || (ev.assistant && ev.assistant.name) || (ev.assistPlayer && ev.assistPlayer.name) || '';
      const playerAssistantName = relatedPlayerName || assistNameFromApi;

      if (ev.type === 'SUBSTITUTION_OUT') {
        items.push({
          id: id,
          type: 'substitution',
          team,
          minute,
          title: 'Cambio',
          playerOut: playerName,
          playerIn: relatedPlayerName
        });
        return;
      }

      if (ev.type === 'GOAL') {
        if (team === 'home') {
          runningHomeScore += 1;
        } else {
          runningAwayScore += 1;
        }
        const currentScoreText = `${runningHomeScore}-${runningAwayScore}`;

        items.push({
          id: id,
          type: 'goal',
          team,
          minute,
          title: ev.name || 'Gol',
          player: playerName,
          playerAssistantName,
          assist: playerAssistantName,
          score: currentScoreText,
          scoreText: currentScoreText
        });
        return;
      }

      items.push({
        id: id,
        type: eventType,
        team,
        minute,
        title: ev.name || '',
        player: playerName,
        extra: relatedPlayerName ? 'Falta en contra: ' + relatedPlayerName : undefined
      });
    });

    return items.reverse();
}

export const buildLineupsData = (matchStats) => {
    if (!matchStats) return null;

    const data = matchStats.data || matchStats;
    const lineupsApi = Array.isArray(data.lineups) ? data.lineups : [];
    if (!lineupsApi.length) return null;

    const matchCard = Array.isArray(data.matchCard) ? data.matchCard[0] : null;
    if (!matchCard) return null;

    const matchDetails = (matchCard.summary || {}).matchDetails || {};
    const homeTeamApi = (matchDetails.home || {}).team || {};
    const awayTeamApi = (matchDetails.away || {}).team || {};
    const homeTeamId = homeTeamApi.teamId || null;

    var EVENT_MAP = {
      YELLOW_CARD: 'yellow',
      RED_CARD: 'red',
      RED_SECOND_YELLOW: 'red_second_yellow',
      RED_SECOND_YELLOW_CARD: 'red_second_yellow',
      SUBSTITUTION_IN: 'sub_in',
      SUBSTITUTION_OUT: 'sub_out',
      GOAL: 'goal',
      OWN_GOAL: 'own_goal',
      SECOND_YELLOW_RED_CARD: 'second_yellow_red_card',
      EXTRA_TIME: 'extra_time'
    };

    var ICON_MAP = {
      goal:              Assets.get('eventodeportivo_icono_gol_2'),
      yellow:            Assets.get('eventodeportivo_icono_amarilla_2'),
      red:               Assets.get('eventodeportivo_icono_roja_2'),
      red_second_yellow: Assets.get('eventodeportivo_icono_amarillaroja_2'),
      sub_in:            Assets.get('eventodeportivo_icono_entra'),
      sub_out:           Assets.get('eventodeportivo_icono_sale'),
    };

    var Y_POSITIONS = {
      1: [50],
      2: [33, 67],
      3: [22, 50, 78],
      4: [18, 38, 62, 82],
      5: [12, 27, 50, 73, 88],
      6: [8, 22, 38, 62, 78, 92]
    };

    var X_POSITIONS = {
      home: { GK: 7, DF: 19, MF: 31, FW: 43 },
      away: { GK: 93, DF: 81, MF: 69, FW: 57 }
    };

    // Parsea "4-3-3" → [4, 3, 3]. Fallback: [4, 3, 3]
    var parseFormation = function(formationStr) {
      if (!formationStr || typeof formationStr !== 'string') return [4, 3, 3];
      var parts = formationStr.split('-').map(function(n) { return parseInt(n, 10); }).filter(function(n) { return !isNaN(n) && n > 0; });
      return parts.length > 0 ? parts : [4, 3, 3];
    };

    // Calcula la X de una línea según su índice (0=GK, 1..n=líneas de campo)
    var getLineX = function(side, lineIndex, totalLines) {
      if (lineIndex === 0) return side === 'home' ? 7 : 93;
      var startX = side === 'home' ? 19 : 81;
      var endX   = side === 'home' ? 43 : 57;
      if (totalLines === 1) return Math.round((startX + endX) / 2);
      return Math.round(startX + (endX - startX) * (lineIndex - 1) / (totalLines - 1));
    };

    // Distribuye N jugadores verticalmente. Extiende la tabla para cualquier N.
    var getYPositions = function(count) {
      if (Y_POSITIONS[count]) return Y_POSITIONS[count];
      var pos = [];
      for (var k = 0; k < count; k++) {
        pos.push(count === 1 ? 50 : Math.round(10 + 80 * k / (count - 1)));
      }
      return pos;
    };

    var countGoals = function(playerMatchDetails) {
      if (!Array.isArray(playerMatchDetails)) return 0;
      var goalCount = 0;
      playerMatchDetails.forEach(function(detail) {
        if (detail.type === 'GOAL' || detail.type === 'OWN_GOAL') {
          goalCount += 1;
        }
      });
      return goalCount;
    };

    var mapPlayerEvents = function(playerMatchDetails) {
      if (!Array.isArray(playerMatchDetails)) return { events: [], iconUrls: {} };
      var events = [];
      var iconUrls = {};
      playerMatchDetails.forEach(function(detail) {
        var eventKey = EVENT_MAP[detail.type];
        if (!eventKey) return;
        if (events.indexOf(eventKey) === -1) events.push(eventKey);
        iconUrls[eventKey] = ICON_MAP[eventKey];
      });
      return { events: events, iconUrls: iconUrls };
    };

    var mapStarters = function(startingXI, side, formation) {
      var formLines = parseFormation(formation);
      var numLines  = formLines.length;
      var starters = [];

      if (!startingXI || startingXI.length === 0) return starters;

      // El primer jugador del array es siempre el portero
      var goalkeeper = startingXI[0];
      var evData = mapPlayerEvents(goalkeeper.playerMatchDetails);
      var subOutDetail = Array.isArray(goalkeeper.playerMatchDetails)
        ? goalkeeper.playerMatchDetails.find(function(d) { return d.type === 'SUBSTITUTION_OUT'; })
        : null;
      var gkPlayer = {
        id: goalkeeper.playerId,
        number: goalkeeper.number,
        name: goalkeeper.name,
        photoUrl: goalkeeper.photo || '',
        x: getLineX(side, 0, numLines),
        y: 50,
        events: evData.events,
        iconUrls: evData.iconUrls,
        goals: countGoals(goalkeeper.playerMatchDetails)
      };
      if (subOutDetail) {
        gkPlayer.subEvent = {
          minute: subOutDetail.minute,
          name: goalkeeper.name || '',
          iconUrl: CANCHA_ICONS.subOut,
          minuteColor: '#d60000'
        };
      }
      starters.push(gkPlayer);

      // Los demás jugadores se toman en orden según la formación
      // Ejemplo: 4-2-1-3 → toma 4 jugadores, luego 2, luego 1, luego 3
      var playerIdx = 1; // Empezamos desde el índice 1 (después del portero)
      formLines.forEach(function(lineCount, li) {
        var lineX       = getLineX(side, li + 1, numLines);
        var linePlayers = startingXI.slice(playerIdx, playerIdx + lineCount);
        playerIdx += lineCount;
        var yArr = getYPositions(linePlayers.length);
        linePlayers.forEach(function(p, i) {
          var evData = mapPlayerEvents(p.playerMatchDetails);
          var subOutDetail = Array.isArray(p.playerMatchDetails)
            ? p.playerMatchDetails.find(function(d) { return d.type === 'SUBSTITUTION_OUT'; })
            : null;
          var player = {
            id: p.playerId,
            number: p.number,
            name: p.name,
            photoUrl: p.photo || '',
            x: lineX,
            y: yArr[i] !== undefined ? yArr[i] : 50,
            events: evData.events,
            iconUrls: Assets.get(evData.iconUrls),
            goals: countGoals(p.playerMatchDetails)
          };
          if (subOutDetail) {
            player.subEvent = {
              minute: subOutDetail.minute,
              name: p.name || '',
              iconUrl: CANCHA_ICONS.subOut,
              minuteColor: '#d60000'
            };
          }
          starters.push(player);
        });
      });

      return starters;
    };

    var mapBench = function(players) {
      return (players || []).map(function(p) {
        var evData = mapPlayerEvents(p.playerMatchDetails);
        var subInDetail = Array.isArray(p.playerMatchDetails)
          ? p.playerMatchDetails.find(function(d) { return d.type === 'SUBSTITUTION_IN'; })
          : null;
        var result = { number: p.number || p.jerseyNumber || p.shirtNumber, name: p.name || p.playerName || '', goals: countGoals(p.playerMatchDetails) };
        if (Object.keys(evData.iconUrls).length) result.iconUrls = evData.iconUrls;
        if (subInDetail) {
          result.subEvent = {
            minute: subInDetail.minute,
            name: p.name || p.playerName || '',
            iconUrl: CANCHA_ICONS.subIn,
            minuteColor: '#56BC37'
          };
        }
        return result;
      });
    };

    var getBenchPlayers = function(lineupEntry) {
      // Intenta todos los nombres de campo posibles que usan las APIs de fútbol
      return lineupEntry.substitutes
        || lineupEntry.bench
        || lineupEntry.reserves
        || lineupEntry.benchPlayers
        || lineupEntry.subs
        || [];
    };

    var getStartingXI = function(lineupEntry) {
      return lineupEntry.startingXI
        || lineupEntry.starters
        || lineupEntry.lineup
        || lineupEntry.players
        || lineupEntry.starting11
        || lineupEntry.xi
        || [];
    };

    var buildTeam = function(lineupEntry, teamApi, side) {
      return {
        name: teamApi.name || '',
        shortName: teamApi.code || '',
        flagUrl: teamApi.flagUrl || '',
        teamColor: teamApi.primaryHex || '',
        formation: lineupEntry.formation || '',
        coach: {
          name: lineupEntry.coach ? lineupEntry.coach.name : '',
          photoUrl: lineupEntry.coach ? lineupEntry.coach.photo : ''
        },
        starters: mapStarters(getStartingXI(lineupEntry), side, lineupEntry.formation),
        bench: mapBench(getBenchPlayers(lineupEntry))
      };
    };

    var homeLineup = lineupsApi.find(function(l) { return l.teamId === homeTeamId; }) || lineupsApi[0];
    var homeLineupId = homeLineup ? homeLineup.teamId : null;
    var awayLineup = lineupsApi.find(function(l) { return l.teamId !== homeLineupId; }) || lineupsApi[1];

    if (!homeLineup || !awayLineup) return null;

    return {
      homeTeam: buildTeam(homeLineup, homeTeamApi, 'home'),
      awayTeam: buildTeam(awayLineup, awayTeamApi, 'away')
    };
}
export const buildHeaderMatchData = (matchStats) => {

if (!matchStats) return null;


const competition = matchStats.competition || {};
const matchCard = Array.isArray(matchStats.matchCard) ? matchStats.matchCard[0] : null;
if (!matchCard) return null;

const { groupCode, status, summary = {} } = matchCard;
const { displayDate, displayTime, timeZoneLabel, venue = {}, attendance, referee = {}, matchDetails = {}, matchProgress = {} } = summary;
const home = matchDetails.home || {};
const away = matchDetails.away || {};
const homeTeamApi = home.team || {};
const awayTeamApi = away.team || {};

const STATUS_LABELS = {
    IN_PROGRESS: 'IN_PROGRESS',
    FINISHED: 'FINISHED',
    COMPLETED: 'COMPLETED',
    SCHEDULED: 'SCHEDULED',
    HALF_TIME: 'HALF_TIME',
};

const normalizeGoals = (goalsSummary) => {
    if (!Array.isArray(goalsSummary)) return [];
    return goalsSummary.map(function (g) {
    return {
        player: g.player ? g.player.name : '',
        minute: g.minuteDisplay ? g.minuteDisplay + "'" + (g.type === 'PENALTY' ? ' (P)' : '') : ''
    };
    });
};

return {
    competition: competition.name || '',
    group: groupCode && groupCode !== '' ? groupCode : null,
    date: displayDate || '',
    time: displayTime || '',
    city: timeZoneLabel || venue.city || '',
    venue: venue.name || '',
    attendance: attendance ? Number(attendance).toLocaleString('es') : '',
    referee: referee.name || '',
    status: matchCard.status,//STATUS_LABELS[status] || status || '',
    homeScore: home.score !== undefined && home.score !== null ? home.score : null,
    awayScore: away.score !== undefined && away.score !== null ? away.score : null,
    stage: matchCard.stage || '',
    homeTeam: {
    name: homeTeamApi.name || '',
    shortName: homeTeamApi.code || '',
    flagUrl: homeTeamApi.flagUrl || '',
    badgeUrl: homeTeamApi.crestUrl || '',
    teamId: homeTeamApi.teamId || '',
    },
    awayTeam: {
    name: awayTeamApi.name || '',
    shortName: awayTeamApi.code || '',
    flagUrl: awayTeamApi.flagUrl || '',
    badgeUrl: awayTeamApi.crestUrl || '',
    teamId: awayTeamApi.teamId || '',
    },
    homeGoals: normalizeGoals(home.goalsSummary),
    awayGoals: normalizeGoals(away.goalsSummary),
    teamColors: {
    home: homeTeamApi.primaryHex || 'rgba(255, 255, 255, 0.25)',
    away: awayTeamApi.primaryHex || 'rgba(255, 255, 255, 0.25)'
    },
    matchProgress
};
}

export const getPhase2Config = () => {
    const metadataValue = Utils.getRegionaliazedMetadata('sports_worldcup_phase2_gracenote_config', null)
    const enabled = metadataValue && metadataValue.enabled ? metadataValue.enabled : null
    return enabled
}

export const getSportsLiveFeedMiniPlayerConfig = () => {
    const metadataValue = Utils.getRegionaliazedMetadata('sports_livefeed_miniplayer_config', null);
    return metadataValue
}

/**
 * Obtiene el nombre de un jugador buscando por participantId en los lineups
 * @param {string} participantId - ID del participante/jugador
 * @param {object} lineups - Objeto con lineups de homeTeam y awayTeam
 * @returns {string|null} - Nombre del jugador o null si no se encuentra
 */
export const getPlayerNameById = (participantId, lineups) => {
  if (!participantId || !lineups) return null;

  // Buscar en lineups de ambos equipos
  const homePlayers = (lineups.homeTeam && Array.isArray(lineups.homeTeam.players)) ? lineups.homeTeam.players : [];
   const awayPlayers = (lineups.awayTeam && Array.isArray(lineups.awayTeam.players)) ? lineups.awayTeam.players : [];
   const allPlayers = homePlayers.concat(awayPlayers);

  const player = allPlayers.find(p => p.id === participantId);
  return player ? player.name : null;
};

/**
 * Obtiene el nombre de un equipo buscando por teamId en matchData
 * @param {string} teamId - ID del equipo
 * @param {object} matchData - Objeto con datos del partido (homeTeam, awayTeam)
 * @returns {string|null} - Nombre del equipo o null si no se encuentra
 */
export const getTeamNameById = (teamId, matchData) => {
   const home = matchData && matchData.homeTeam ? matchData.homeTeam : {};
   const away = matchData && matchData.awayTeam ? matchData.awayTeam : {};
   if (home.id === teamId) return home.name || null;
   if (away.id === teamId) return away.name || null;

  return null;
};

/**
 * Mapea el payload de una acción desde la API al formato interno
 * @param {object} action - Acción desde la API con estructura action.recorded
 * @param {object} matchData - Datos completos del partido para lookups
 * @returns {object} - Acción en formato interno normalizado
 */
export const mapLiveMatchActionPayload = (action, matchData) => {
     if (!action || !action.payload || !matchData) return null;

  const payload = action.payload;
  const lineups = matchData.lineups || null;
  // Intentar obtener nombre del jugador desde lineups
  const playerName = getPlayerNameById(payload.participantId, lineups);

  let playerOut = '';
  let playerIn = '';
  if (payload.type === 'SUBSTITUTION_OUT') {
    playerOut = playerName || payload.participantName || '';
    playerIn = payload.relatedPlayerName || '';
  } else if (payload.type === 'SUBSTITUTION_IN') {
    playerIn = playerName || payload.participantName || '';
    playerOut = payload.relatedPlayerName || '';
  }

  return {
    id: payload.actionId,
    type: payload.type,
    typeLabel: payload.displayName || payload.type,
    minute: payload.minute,
    second: payload.second,
    player: playerName || payload.displayName || null,
    team: getTeamNameById(payload.teamId, matchData),
    description: payload.displayName || payload.type,
    teamId: payload.teamId, // Mantener para lógica de scores
    participantId: payload.participantId,  // Mantener para referencia
    streamEventId: action.streamEventId || null,
    eventId: action.eventId || null,
    actionId: payload.actionId,
    matchId: payload.matchId,
    eventType: action.eventType || null,
    eventVersion: action.eventVersion || null,
    topic: action.topic || null,
    occurredAt: action.occurredAt || null,
    receivedAt: action.receivedAt || null,
    timestamp: payload.timestamp || null,
    description: payload.displayName || payload.type,
    order: payload.order || null,
    time: payload.time || null,
    minute: payload.minute,
    second: payload.second,
    minuteDisplay: payload.minuteDisplay || payload.minute,
    periodNumber: payload.periodNumber || null,
    periodType: payload.periodType || null,
    team: getTeamNameById(payload.teamId, matchData),
    player: playerName || payload.participantName || null,
    participantName: payload.participantName || null,
    participantType: payload.participantType || null,
    participantNumber: payload.participantNumber || null,
    score: payload.score,
    scoreText: payload.score,
    relatedPlayerName: payload.relatedPlayerName || null,
    playerOut: playerOut,
    playerIn: playerIn,
    relatedTeam: getTeamNameById(payload.relatedTeamId, matchData),
  };
};

export const normalizeText = (text) => {
  if (!text) return null
  return text
    .toString()
    .toLowerCase()
    .replace(/[áàäâã]/g, 'a')
    .replace(/[éèëê]/g, 'e')
    .replace(/[íìïî]/g, 'i')
    .replace(/[óòöôõ]/g, 'o')
    .replace(/[úùüû]/g, 'u')
    .replace(/[ñ]/g, 'n')
    .replace(/[ç]/g, 'c')
}

export const getIsFinishedMatch = (matchStatus) => {
  return matchStatus === 'FINISHED' || matchStatus === 'COMPLETED'
}

export const getMatchName = (homeTeam, awayTeam) => {
  if (!homeTeam || !awayTeam) {
    return null
  }

  return `${normalizeText(homeTeam.name)} vs ${normalizeText(awayTeam.name)}`
}

export const getMatchScore = (homeTeam, awayTeam) => {
  if (!homeTeam || !awayTeam) {
    return null
  }

  return `${homeTeam.score} - ${awayTeam.score}`
}

export const getMatchWinner = (homeTeam, awayTeam) => {
  if (!homeTeam || !awayTeam) {
    return null
  }

  if (
    typeof homeTeam.score !== 'number' ||
    typeof awayTeam.score !== 'number'
  ) {
    return null
  }

  if (homeTeam.score > awayTeam.score) {
    return normalizeText(homeTeam.name) || null
  }

  if (awayTeam.score > homeTeam.score) {
    return normalizeText(awayTeam.name) || null
  }

  return null
}

export const getPlaybackAktSeedConfig = () => {
    const metadataValue = Utils.getRegionaliazedMetadata('playback_akt_seed_config', PLAYBACK_AKT_SEED_CONFIG_DEFAULT);
    return metadataValue
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/utils.js